/** Shared check-in dialog (Participants admin list + Competitions check-in). */
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import CheckinForm from 'src/common/forms/CheckinForm';
import DialogTitle from 'src/common/components/DialogTitle';
import Loader from 'src/common/components/Loader';
import { ICheckin, IFormCheckin } from 'src/interfaces/Checkin';
import { IEnrichedParticipant, IParticipant } from 'src/interfaces/Participant';

interface Props extends DialogProps {
  handleClose: () => void;
  handleSave: (checkin: IFormCheckin, id?: string) => void;
  isLoading?: boolean;
  selectedApplicant?: IParticipant | IEnrichedParticipant;
  selectedCheckin?: ICheckin;
}

const CheckinModal = ({
  id,
  isLoading,
  open,
  handleClose,
  handleSave,
  selectedApplicant,
  selectedCheckin,
}: Props) => {
  const { t } = useTranslation();
  const participant = selectedCheckin ? selectedCheckin.participant : selectedApplicant;
  const formKey =
    selectedCheckin?.id ||
    selectedApplicant?.id ||
    (selectedApplicant as IEnrichedParticipant | undefined)?.registration?.id ||
    'checkin-form';

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby={`${id}-modal-title`}>
      <Loader isLoading={isLoading} />
      <DialogTitle id={`${id}-modal-title`} onClose={handleClose}>
        {participant
          ? t('checkins.checkinModalTitle', {
              name: `${participant.lastName} ${participant.firstName}`,
            })
          : '?'}
      </DialogTitle>
      {open && (selectedApplicant || selectedCheckin) ? (
        <CheckinForm
          key={formKey}
          handleSave={handleSave}
          handleClose={handleClose}
          selectedApplicant={selectedApplicant as IEnrichedParticipant | undefined}
          selectedCheckin={selectedCheckin}
        />
      ) : null}
    </Dialog>
  );
};

export default CheckinModal;
